import { getFeature } from 'Cloud/Application/FeaturesEs6';
import type { quotaStates } from 'server/types/context/IUser';

import { overquotaNewFullBlocked, overquotaNewFullBlockedModal } from './overquotaNewFullBlocked';

// CLOUDWEB-18435
// Добавить проверку значения текущей квоты для всех статусов (кроме after_clear, restore_requested, cleared)
export const overStatesCheckedByQuota: quotaStates[] = getFeature('overq-states-checked-by-quota') || [
    'started',
    'blocked',
    'unblocked',
    'new',
];

if (overquotaNewFullBlocked || overquotaNewFullBlockedModal) {
    overStatesCheckedByQuota.push('full_blocked');
}

// Новый флоу определения оверквотера (выкидываем учет фичи overquotaNewFullBlocked. Просто выкинуть пока не можем)
export const overStatesCheckedByQuotaNew: quotaStates[] = getFeature('overq-states-checked-by-quota') || [
    ...overStatesCheckedByQuota,
    'full_blocked',
];
